import React from 'react'

class ExpensesReviewAlert extends React.Component {
  hasInvalidRow() {
    return this.props.invalidExpenses && this.props.invalidExpenses.length
  }

  render() {
    if (this.hasInvalidRow()) {
      return (
        <div className='alert alert-danger fixed d-flex mb-4' role='alert'>
          <div className='col-auto p-0'>
            <i className='fa fa-exclamation-circle mt-3' aria-hidden="true" />
          </div>
          <div className='col pr-0'>
            <p>
              <strong>Some expenses need to be reviewed</strong><br/>
              It seems you left a field selected without entering an amount.
            </p>
            <p className='mb-0'>
              If an expense does not apply to you, de-select it’s checkbox. If it does,
              we require you to enter an amount. Please review the following:
            </p>

            <ul className='mt-2 mb-0'>
              {
                this.props.invalidExpenses.map((text, index) => (<li key={index}>
                  { text }
                </li>))
              }
            </ul>
          </div>
        </div>
      );
    }

    return null;
  }
}

export default ExpensesReviewAlert;
